(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('weekschemeTime', ['DayschemeTimesService', 'SchemeBroadcast', '$translate', WeekschemeTimeDirectiveFn]);
    // one time object in weekscheme
    function WeekschemeTimeDirectiveFn(DayschemeTimesService, SchemeBroadcast, $translate)  {
        var directive = {
            link: link,
            restrict: 'E',
            templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekscheme-time.template.html'
        };
        return directive;

        function link(scope, element, attrs) {
            var el = element.find('label');

            var bgClass = '';
            var bgFontClass = '';

            // first select 
            set();

          
            // element.on('mouseenter', function (event) {
            //     if (event.button === 0 && DayschemeTimesService.data.keyDown === true) {
            //         remove();
            //         DayschemeTimesService.select(scope.cell);
            //         set();
            //     } //if
            // });

            element.on('mousedown', function (event) {
                if (event.button === 0) {
                    remove();
                    DayschemeTimesService.data.keyDown = true;
                    DayschemeTimesService.select(scope.cell);
                    set();
                    scope.$apply();
                } //if
            });
 
            element.on('mouseup', function (event) {
                DayschemeTimesService.data.keyDown = false;
            });

            // listener 
            var binder = scope.$on(SchemeBroadcast.DaySelected, function () {
                remove();
                set();
            });


            // remove classes
            function remove() {
                element.removeClass(bgClass);
                el.removeClass(bgFontClass);
                el.find('p').remove();
                bgClass = '';
                bgFontClass = '';
            } // set

            // set classes
            function set() {
                //// new classes
                if (scope.cell.agendaLabelDto !== null) {
                    bgClass = 'bg-' + scope.cell.agendaLabelDto.colorCaption;
                    bgFontClass = 'bg-font-' + scope.cell.agendaLabelDto.colorCaption;

                    element.addClass(bgClass);
                    el.addClass(bgFontClass);
                        
                    // add span
                    var labelText = scope.cell.agendaLabelDto.text || $translate.instant('label_without_caption');
                    var span = `<p class="clearfix" title="${labelText}" 
                                   style="font-size:x-small;width:90%;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                                   ${labelText}
                                </p>`;
                    el.append(span);
                } // if  
            } // set          

            // on destroy
            scope.$on('$destroy', function () {
                element.off('mouseenter');
                element.off('mousedown');
                element.off('mouseup');
                bgClass = null;
                bgFontClass = null;
                el = null;
                binder();
                binder = null;
            });

        }
    }

})();